<template>
  <CSidebar
    aside
    :show="$store.state.courierInternalNotesAsideShow"
    @update:show="(val) => $store.commit('set', ['courierInternalNotesAsideShow', val])"
    colorScheme="light"
    overlaid
    size="lg"
  >
    <CSidebarClose @click.native="$store.commit('toggle', 'courierInternalNotesAsideShow')" />

    <CListGroup class="scrollable list-group-accent mt-5">
      <CListGroupItem class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-uppercase">
        Internal Notes
        <span v-if="courier" class="d-block text-muted mt-2">#{{ courier.id }} - {{ courier.first_name }}</span>
      </CListGroupItem>

      <template v-if="sortedNotes.length > 0">
        <CListGroupItem 
          v-for="(note, index) in sortedNotes" 
          :key="note.id" 
          class="list-group-item-divider"
        >
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="d-flex align-items-center small">
              <CIcon name="cil-note-add" class="mr-2 text-info"/>
              <strong>{{ note.created_by_name || 'System' }}</strong>
            </div>
            <div class="text-right">
              <span class="text-muted small">{{ $globalFunc.formatDateTime(note.created_at) }}</span>
            </div>
          </div>
          <div class="note-content">
            <p class="mb-1">{{ note.content }}</p>
          </div>
        </CListGroupItem>
      </template>
      
      <template v-else>
        <CListGroupItem class="list-group-item-divider">
          <div class="text-center py-4">
            <CIcon name="cil-speech" size="3xl" class="text-muted mb-3"/>
            <p class="text-muted mb-0">No internal notes found for this courier.</p>
          </div>
        </CListGroupItem>
      </template>
    </CListGroup>
  </CSidebar>
</template>

<script>
export default {
  name: "CourierInternalNotes",
  props: {
    courier: {
      type: Object,
      default: null
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    sortedNotes() {
      if (!this.courier?.detail?.internal_notes) {
        return [];
      }
      
      // Sort notes by created_at in descending order (newest first)
      return [...this.courier.detail.internal_notes].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
  },
};
</script>

<style scoped>
.scrollable {
  overflow-y: auto;
  height: 100%;
}

.note-content {
  word-wrap: break-word;
  line-height: 1.4;
}

.note-content p {
  white-space: pre-wrap;
}
</style> 